import { useMemo } from 'react'
import { useAppSelector } from 'app/state'

// Returns an object with {dataset_id: letter} relations
function useDatasetsLetters(): Record<string, string> {
  const datasets = useAppSelector((state) => state.maps.currentMapDatasets)

  const letters = useMemo(() => {
    return datasets.reduce((result, dataset, index) => {
      result[dataset.id] = String.fromCharCode(65 + index)
      return result
    }, {})
  }, [datasets])

  return letters
}

export default useDatasetsLetters
